export default function Field({
  label,
  name,
  type = 'text',
  placeholder,
  required,
  as,
  options,
  rows,
  value,
  error,
  onChange,
  multiple,
}) {
  return (
    <div className="form-group">
      <label className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>

      {as === 'checkboxes' ? (
        <div className={`checkbox-group${error ? ' error' : ''}`}>
          {options.map((o) => (
            <label key={o} className="checkbox-option">
              <input
                type="checkbox"
                name={name}
                value={o}
                checked={Array.isArray(value) && value.includes(o)}
                onChange={onChange}
              />
              <span>{o}</span>
            </label>
          ))}
        </div>
      ) : as === 'select' ? (
        <select
          name={name}
          value={value}
          onChange={onChange}
          className={`form-control${error ? ' error' : ''}`}
          multiple={multiple}
        >
          {!multiple && <option value="">Select {label}</option>}

          {options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      ) : as === 'textarea' ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          className={`form-control${error ? ' error' : ''}`}
          placeholder={placeholder}
          rows={rows || 4}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          className={`form-control${error ? ' error' : ''}`}
          placeholder={placeholder}
        />
      )}

      {error && <span className="form-error">⚠ {error}</span>}
    </div>
  );
}
